var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "500px" },
        },
        [
          _c(
            "BjDivider",
            { attrs: { "right-fixed": "" } },
            [
              _vm._v(_vm._s(_vm.$t("StockRules.Header.title")) + " "),
              _c(
                "template",
                { slot: "right" },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission:SettingStockRulesConfig_Save",
                          arg: "SettingStockRulesConfig_Save",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("resetText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission:SettingStockRulesConfig_Save",
                          arg: "SettingStockRulesConfig_Save",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Header.method"),
                prop: "radixPointComputeMode",
              },
            },
            [
              _c("BjRadioLov", {
                attrs: { "option-list": _vm.RADIX_POINT_COMPUTED_MODE_LIST },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(" " + _vm._s(_vm.$t(item.label)) + " "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top-start",
                              content:
                                item.value === "trunc"
                                  ? _vm.$t("StockRules.Header.down")
                                  : _vm.$t("StockRules.Header.up"),
                            },
                          },
                          [_c("i", { staticClass: "el-icon-question" })]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.form.radixPointComputeMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "radixPointComputeMode", $$v)
                  },
                  expression: "form.radixPointComputeMode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Header.shortage"),
                prop: "backordersPriorityStatus",
              },
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.backordersPriorityStatus,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "backordersPriorityStatus", $$v)
                  },
                  expression: "form.backordersPriorityStatus",
                },
              }),
              _vm.form.backordersPriorityStatus
                ? _c(
                    "el-button",
                    {
                      staticClass: "ml10",
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.ChannelSort.show(
                            _vm.backordersChannelPriorityArray,
                            "backordersChannelPriorityArray"
                          )
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("StockRules.Header.channel")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.form.backordersPriorityStatus
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("StockRules.Header.rule"),
                    prop: "backordersPriorityRule",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.backordersPriorityRule,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "backordersPriorityRule", $$v)
                        },
                        expression: "form.backordersPriorityRule",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "8px" } },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(
                              _vm._s(_vm.$t("StockRules.Header.delivery")) + " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "8px" } },
                        [
                          _c(
                            "el-radio",
                            { attrs: { label: false } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("StockRules.Header.quantity")) +
                                  " "
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.form.backordersPriorityRule ==
                                        false,
                                      expression:
                                        "form.backordersPriorityRule == false",
                                    },
                                  ],
                                  staticStyle: { "margin-left": "8px" },
                                  model: {
                                    value: _vm.form.backordersNumberRule,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "backordersNumberRule",
                                        $$v
                                      )
                                    },
                                    expression: "form.backordersNumberRule",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("StockRules.Header.quan"))
                                    ),
                                  ]),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("StockRules.Header.tity"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("StockRules.Main.title")))]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Main.Channel"),
                prop: "channelPriority",
              },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.ChannelSort.show(
                        _vm.channelPriorityArray,
                        "channelPriorityArray"
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("settingText")))]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Main.Virtual"),
                prop: "virtualReplenishPriorityRule",
              },
            },
            [
              _c("el-link", { attrs: { type: "warning", underline: false } }, [
                _vm._v(_vm._s(_vm.$t("StockRules.Main.Drag"))),
              ]),
              _c(
                "div",
                { attrs: { id: "virtualReplenishPriorityRule" } },
                _vm._l(
                  _vm.STOCK_WAREHOUSE_TYPE_SON_1_LIST_VIRTUAL,
                  function (e) {
                    return _c(
                      "div",
                      {
                        key: e.value,
                        staticClass: "sort-item virtualReplenishPriorityRule",
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.$t(e.label)) + " "),
                        _c("svg-icon", {
                          staticClass: "virtualReplenishPriorityRule-handle",
                          attrs: { "icon-class": "pointer" },
                        }),
                      ],
                      1
                    )
                  }
                ),
                0
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Main.rule"),
                prop: "sameVirtualReplenishPriorityRule",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.sameVirtualReplenishPriorityRule,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "sameVirtualReplenishPriorityRule",
                        $$v
                      )
                    },
                    expression: "form.sameVirtualReplenishPriorityRule",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "8px" } },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("StockRules.Main.less")) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "8px" } },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: 1 } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("StockRules.Main.creation")) + " "
                          ),
                          _c(
                            "el-radio-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.sameVirtualReplenishPriorityRule ==
                                    1,
                                  expression:
                                    "form.sameVirtualReplenishPriorityRule == 1",
                                },
                              ],
                              staticStyle: { "margin-left": "8px" },
                              model: {
                                value: _vm.form.virtualDateSort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "virtualDateSort", $$v)
                                },
                                expression: "form.virtualDateSort",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(_vm._s(_vm.$t("StockRules.Main.near"))),
                              ]),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("StockRules.Main.far"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "8px" } },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: 2 } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("StockRules.Main.warehouse")) + " "
                          ),
                          _c(
                            "el-radio-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.sameVirtualReplenishPriorityRule ==
                                    2,
                                  expression:
                                    "form.sameVirtualReplenishPriorityRule == 2",
                                },
                              ],
                              staticStyle: { "margin-left": "8px" },
                              model: {
                                value: _vm.form.virtualSpaceSort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "virtualSpaceSort", $$v)
                                },
                                expression: "form.virtualSpaceSort",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(_vm._s(_vm.$t("StockRules.Main.high"))),
                              ]),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("StockRules.Main.low"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("StockRules.Bottom.title")))]),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Bottom.Inventory"),
                prop: "stockDeductionPriorityRule",
              },
            },
            [
              _c("el-link", { attrs: { type: "warning", underline: false } }, [
                _vm._v(_vm._s(_vm.$t("StockRules.Bottom.Drag"))),
              ]),
              _c(
                "div",
                { attrs: { id: "stockDeductionPriorityRule" } },
                _vm._l(_vm.STOCK_WAREHOUSE_TYPE_SON_1_LIST_STOCK, function (e) {
                  return _c(
                    "div",
                    {
                      key: e.value,
                      staticClass: "sort-item stockDeductionPriorityRule",
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t(e.label)) + " "),
                      _c("svg-icon", {
                        staticClass: "stockDeductionPriorityRule-handle",
                        attrs: { "icon-class": "pointer" },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockRules.Bottom.rules"),
                prop: "subVirtualReplenishPriorityRule",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.subVirtualReplenishPriorityRule,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "subVirtualReplenishPriorityRule", $$v)
                    },
                    expression: "form.subVirtualReplenishPriorityRule",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "8px" } },
                    [
                      _c(
                        "el-radio",
                        { attrs: { label: 1 } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("StockRules.Bottom.creation")) + " "
                          ),
                          _c(
                            "el-radio-group",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.subVirtualReplenishPriorityRule ==
                                    1,
                                  expression:
                                    "form.subVirtualReplenishPriorityRule == 1",
                                },
                              ],
                              staticStyle: { "margin-left": "8px" },
                              model: {
                                value: _vm.form.subVirtualDateSort,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "subVirtualDateSort", $$v)
                                },
                                expression: "form.subVirtualDateSort",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("StockRules.Bottom.near"))
                                ),
                              ]),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(_vm._s(_vm.$t("StockRules.Bottom.far"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("StockRules.Footer.title")))]),
          _c(
            "el-form-item",
            { attrs: { label: "", prop: "inventoryOversoldRatio" } },
            [
              _vm._v(" " + _vm._s(_vm.$t("StockRules.Footer.total")) + " "),
              _c("el-input-number", {
                attrs: { min: 100, max: 500, precision: 0, controls: false },
                model: {
                  value: _vm.form.inventoryOversoldRatio,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "inventoryOversoldRatio", $$v)
                  },
                  expression: "form.inventoryOversoldRatio",
                },
              }),
              _vm._v(" % "),
              _c("p", { staticClass: "tips" }, [
                _vm._v(_vm._s(_vm.$t("StockRules.Footer.The"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("ChannelSort", {
        ref: "ChannelSort",
        on: { confirm: _vm.handleChannelSortConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }